// import React, { useEffect, useState } from "react";
// import { Avatar } from "@mui/joy";
// import { useDispatch } from "react-redux";
// import { useSelector } from "react-redux";
// import { get_all_payments, download_invoice } from "../../reduxData/user/userAction";
// import { formatInTimeZone } from "date-fns-tz";
// import EmptyData from "../../components/EmptyData";
// import DefaultImg from "../../images/no_profile.png";
// import CustomPagination from "../../components/CustomPagination";
// import { useTranslation } from "react-i18next";

// const Payments = () => {
//     const { t } = useTranslation();
//     const { user, accessToken, userPermissions } = useSelector((state) => state.auth);
//     const { paymentLists, totalPayments } = useSelector((state) => state.user);
//     const dispatch = useDispatch();
//     const [loading, setLoading] = useState(false);
//     const { REACT_APP_IMAGE_URL, REACT_APP_BASE_URL } = process.env;

//     // fetch payment data 
//     const fetchData = async () => {
//         await get_all_payments(dispatch, 1, 10);
//     };

//     // call fetch data function 
//     useEffect(() => {
//         fetchData();
//     }, []);

//     // payment status classes 
//     const statusClassMap = {
//         success: 'approved',
//         succeeded: 'approved',
//         failed: 'cancelled',
//         pending: 'pending',
//     };

//     // download invoice function 
//     const downloadInvoice = async (data) => {
//         setLoading(true)
//         try {
//             setLoading(true)
//             const response = await download_invoice(dispatch, data?.order_id);
//             const blob = response.data;
//             if (blob.size === 0) {
//                 throw new Error("Received empty file from server");
//             }
//             const url = window.URL.createObjectURL(blob);
//             const link = document.createElement("a");
//             link.href = url;
//             link.download = `invoice-${data?.order_id || "download"}.pdf`;
//             document.body.appendChild(link);
//             link.click();
//             setTimeout(() => {
//                 document.body.removeChild(link);
//                 window.URL.revokeObjectURL(url);
//             }, 100);
//             setLoading(false)
//         } catch (error) {
//             console.error("Download failed:", error);
//         }
//         setLoading(false)
//     };


//     return (
//         <div>
//             <div className="container">
//                 <h3 className="mb-0 fw-600">{t("payments.title")}</h3>
//                 <div className="table-responsive mt-4">
//                     <table className="table table-hover user-management-table">
//                         <thead className="border-gray">
//                             <th>{t("payments.serialNumber")}</th>
//                             <th>{t("order.OrderId")}</th>
//                             <th>{t("payments.amount")}</th>
//                             <th>{t("payments.paymentDate")}</th>
//                             <th>{t("payments.buyerStatus")}</th>
//                             <th>{t("payments.sellerStatus")}</th>
//                             <th>{t("payments.action")}</th>
//                         </thead>
//                         <tbody>
//                             {Array.isArray(paymentLists) && totalPayments > 0 ? (
//                                 paymentLists?.map((item, index) => (
//                                     <React.Fragment key={index}>
//                                         <tr>
//                                             <td>{index + 1}.</td>
//                                             <td>{item.order_id}.</td>
//                                             <td className="">
//                                                 {item?.paid_amount !== "null" && item?.paid_amount !== "0" ? `€ ${item?.paid_amount}` : "€ 0"}
//                                             </td>
//                                             <td>
//                                                 {item?.created_at
//                                                     ? formatInTimeZone(
//                                                         new Date(item.created_at),
//                                                         "UTC",
//                                                         "MM/dd/yyyy / hh:mm a"
//                                                     )
//                                                     : t("common.naFallback")}
//                                             </td>
//                                             <td>
//                                                 <div
//                                                     className={`status-badge ${statusClassMap[item?.status] || ''
//                                                         }`}>
//                                                     <span>
//                                                         {item?.status?.charAt(0).toUpperCase() +
//                                                             item?.status?.slice(1)}
//                                                     </span>
//                                                 </div>
//                                             </td>

//                                             <td>
//                                                 <div
//                                                     className={`status-badge ${statusClassMap[item?.seller_payment_status]
//                                                         }`}>
//                                                     <span>
//                                                         {item?.seller_payment_status?.charAt(0).toUpperCase() +
//                                                             item?.seller_payment_status?.slice(1)}
//                                                     </span>
//                                                 </div>
//                                             </td>
//                                             <td className="text-center">
//                                                 {item?.status === "failed" ||
//                                                     item?.status === "cancelled" ||
//                                                     item?.status === "pending" ||
//                                                     item?.status === null ? (
//                                                     <>-</>
//                                                 ) :
//                                                     <>
//                                                         <button
//                                                             onClick={() => downloadInvoice(item)}
//                                                             className={`orange-btn ${loading ? 'cursor-default' : 'cursor-pointer'}`}
//                                                             disabled={loading ? true : false} >
//                                                             <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                                                                 <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
//                                                                 <polyline points="7 10 12 15 17 10"></polyline>
//                                                                 <line x1="12" y1="15" x2="12" y2="3"></line>
//                                                             </svg>
//                                                             {t("payments.downloadInvoice")} {loading && "..."}
//                                                         </button>
//                                                     </>}
//                                             </td>
//                                         </tr>
//                                     </React.Fragment>
//                                 ))
//                             ) : (<EmptyData />)}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>

//             <div className="mt-3">
//                 {totalPayments > 0 && (
//                     <CustomPagination
//                         total={totalPayments}
//                         onPageChange={(page, perPage) => {
//                             get_all_payments(dispatch, page, perPage,);
//                         }}
//                     />
//                 )}
//             </div>

//         </div>
//     );
// };

// export default Payments;









import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    get_all_payments,
    download_invoice,
} from "../../reduxData/user/userAction";
import EmptyData from "../../components/EmptyData";
import CustomPagination from "../../components/CustomPagination";
import { StatusBadge } from "../../components/StatusBadge";
import { formatDateTime } from "../../hooks/formatDateTime";
import { formatPrice } from "../../hooks/formatPrice";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Payments = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const { paymentLists, totalPayments } = useSelector(
        (state) => state.user
    );
    const [downloadingId, setDownloadingId] = useState(null);
    const [width, setWidth] = useState(window.innerWidth);

    const isMobile = width <= 750;

    // Handle responsive view
    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    // Fetch payment data
    const fetchData = async (page = 1, perPage = 10) => {
        await get_all_payments(dispatch, page, perPage);
    };

    useEffect(() => {
        fetchData();
    }, [dispatch]);

    // Payment status classes
    const getPaymentStatusClass = (status) => {
        const normalizedStatus = status?.toLowerCase();

        if (
            normalizedStatus === "success" ||
            normalizedStatus === "succeeded" ||
            normalizedStatus === "paid" ||
            normalizedStatus === "completed"
        ) {
            return "bg-success";
        }

        if (
            normalizedStatus === "pending" ||
            normalizedStatus === "processing"
        ) {
            return "bg-warning text-dark";
        }

        if (
            normalizedStatus === "failed" ||
            normalizedStatus === "cancelled" ||
            normalizedStatus === "canceled"
        ) {
            return "bg-danger";
        }

        if (
            normalizedStatus === "blocked" ||
            normalizedStatus === "on_hold"
        ) {
            return "bg-danger";
        }

        return "bg-secondary";
    };

    // If the buyer payment itself failed/was cancelled, the seller payout
    // never gets created, so show it as cancelled instead of "Unknown".
    const getSellerPayoutStatus = (item) => {
        if (item?.seller_payment_status) return item.seller_payment_status;

        const buyerStatus = item?.status?.toLowerCase();
        if (["failed", "payment_failed", "cancelled", "canceled"].includes(buyerStatus)) {
            return "cancelled";
        }

        return item?.seller_payment_status;
    };

    // Check whether invoice is available
    const canDownloadInvoice = (status) => {
        const normalizedStatus = status?.toLowerCase();

        return [
            "success",
            "succeeded",
            "paid",
            "completed",
        ].includes(normalizedStatus);
    };

    const formatAmount = (amount) => formatPrice(amount, i18n);

    // Download invoice
    const downloadInvoice = async (item) => {
        const orderId = item?.order_id || item?.orderId;

        if (!orderId || downloadingId) {
            return;
        }

        try {
            setDownloadingId(orderId);

            const response = await download_invoice(dispatch, orderId);
            const blob = response?.data;

            if (!(blob instanceof Blob) || blob.size === 0) {
                throw new Error("Received an empty invoice file");
            }

            const fileUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = fileUrl;
            link.download = `invoice-${orderId}.pdf`;

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(fileUrl);
        } catch (error) {
            console.error("Invoice download failed:", error);
        } finally {
            setDownloadingId(null);
        }
    };

    // Desktop payment table
    const DesktopTable = () => (
        <div className="si-table-wrapper">
            <table className="si-table">
                <colgroup>
                    <col className="si-col-toggle" />
                    <col className="si-col-order" />
                    <col className="si-col-amount" />
                    <col className="si-col-date" />
                    <col className="si-col-status" />
                    <col className="si-col-status" />
                    <col className="si-col-action" />
                </colgroup>

                <thead className="si-thead">
                    <tr>
                        <th className="si-th si-th--center">
                            {t("payments.serialNumber")}
                        </th>
                        <th className="si-th">
                            {t("order.OrderId")}
                        </th>
                        <th className="si-th si-th--center">
                            {t("payments.amount")}
                        </th>
                        <th className="si-th si-th--center">
                            {t("payments.paymentDate")}
                        </th>
                        <th className="si-th si-th--center">
                            {t("payments.buyerStatus")}
                        </th>
                        <th className="si-th si-th--center">
                            {t("payments.sellerStatus")}
                        </th>
                        <th className="si-th si-th--center">
                            {t("payments.action")}
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {paymentLists?.map((item, index) => {
                        const orderId =
                            item?.order_id || item?.orderId;

                        const isDownloading =
                            downloadingId === orderId;

                        const invoiceAvailable =
                            canDownloadInvoice(item?.status);

                        return (
                            <tr
                                key={item?.id || orderId || index}
                                className="si-row si-row--parent"
                            >
                                <td className="si-td si-td--center">
                                    <span className="si-count-badge">
                                        {index + 1}
                                    </span>
                                </td>

                                <td className="si-td">
                                    <span className="si-order-id">
                                        {orderId ? <Link to={`/order/${orderId}`}>{orderId}</Link> : "—"}
                                    </span>
                                </td>

                                <td className="si-td si-td--center">
                                    <span className="si-amount">
                                        {formatAmount(item?.paid_amount)}
                                    </span>
                                </td>

                                <td className="si-td si-td--center si-date">
                                    {item?.created_at
                                        ? formatDateTime(item.created_at, i18n)
                                        : t("common.naFallback")}
                                </td>

                                <td className="si-td si-td--center">
                                    <StatusBadge
                                        status={item?.status}
                                        getClass={getPaymentStatusClass}
                                    />
                                </td>

                                <td className="si-td si-td--center">
                                    <StatusBadge
                                        status={getSellerPayoutStatus(item)}
                                        getClass={getPaymentStatusClass}
                                    />
                                </td>

                                <td className="si-td si-td--center">
                                    {invoiceAvailable ? (
                                        <button type="button"
                                            className={`si-view-btn si-download-btn ${isDownloading
                                                ? "cursor-default"
                                                : "cursor-pointer"
                                                }`}
                                            onClick={() => downloadInvoice(item)}
                                            disabled={isDownloading}
                                        >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                                <polyline points="7 10 12 15 17 10" />
                                                <line x1="12" y1="15" x2="12" y2="3" />
                                            </svg>
                                            <span>
                                                {t("payments.downloadInvoice")}
                                                {isDownloading && <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                                    <path d="M0 0h24v24H0z" fill="none" />
                                                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 6.99998C9.1747 6.99987 6.99997 9.24998 7 12C7.00003 14.55 9.02119 17 12 17C14.7712 17 17 14.75 17 12">
                                                        <animateTransform attributeName="transform" attributeType="XML" dur="560ms" from="0,12,12" repeatCount="indefinite" to="360,12,12" type="rotate" />
                                                    </path>
                                                </svg>
                                                }
                                            </span>
                                        </button>
                                    ) : (
                                        <span className="si-no-action">
                                            —
                                        </span>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );

    // Mobile payment cards
    const MobileCards = () => (
        <div className="si-mobile-list">
            {paymentLists?.map((item, index) => {
                const orderId =
                    item?.order_id || item?.orderId;

                const isDownloading =
                    downloadingId === orderId;

                const invoiceAvailable =
                    canDownloadInvoice(item?.status);

                return (
                    <div
                        key={item?.id || orderId || index}
                        className="si-card"
                    >
                        <div className="si-card-header">
                            <div className="si-card-header-left">
                                <span className="si-card-order-id">
                                    #{orderId ? <Link to={`/order/${orderId}`}>{orderId}</Link> : "—"}
                                </span>

                                <span className="si-card-date">
                                    {item?.created_at
                                        ? formatDateTime(item.created_at, i18n)
                                        : t("common.naFallback")}
                                </span>
                            </div>

                            <span className="si-card-amount">
                                {formatAmount(item?.paid_amount)}
                            </span>
                        </div>

                        <div className="si-card-badges">
                            <div className="si-card-badge-group">
                                <span className="si-card-badge-label">
                                    {t("payments.buyerStatus")}
                                </span>
                                <StatusBadge
                                    status={item?.status}
                                    getClass={getPaymentStatusClass}
                                />
                            </div>

                            <div className="si-card-badge-group">
                                <span className="si-card-badge-label">
                                    {t("payments.sellerStatus")}
                                </span>

                                <StatusBadge
                                    status={getSellerPayoutStatus(item)}
                                    getClass={getPaymentStatusClass}
                                />
                            </div>
                        </div>

                        <div className="si-card-footer">
                            {invoiceAvailable ? (
                                <button type="button"
                                    className={`si-view-btn si-download-btn ${isDownloading
                                        ? "cursor-default"
                                        : "cursor-pointer"
                                        }`}
                                    onClick={() => downloadInvoice(item)}
                                    disabled={isDownloading}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                        <polyline points="7 10 12 15 17 10" />
                                        <line x1="12" y1="15" x2="12" y2="3" />
                                    </svg>
                                    <span>
                                        {t("payments.downloadInvoice")}
                                        {isDownloading && <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                            <path d="M0 0h24v24H0z" fill="none" />
                                            <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 6.99998C9.1747 6.99987 6.99997 9.24998 7 12C7.00003 14.55 9.02119 17 12 17C14.7712 17 17 14.75 17 12">
                                                <animateTransform attributeName="transform" attributeType="XML" dur="560ms" from="0,12,12" repeatCount="indefinite" to="360,12,12" type="rotate" />
                                            </path>
                                        </svg>}
                                    </span>
                                </button>
                            ) : (
                                <span className="si-no-action">
                                    {t("common.naFallback")}
                                </span>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );

    const hasPayments =
        Array.isArray(paymentLists) &&
        paymentLists.length > 0 &&
        totalPayments > 0;

    return (
        <div className="si-page container">
            <div className="si-page-header">
                <h3 className="mb-0 fw-600">
                    {t("payments.title")}
                </h3>
            </div>

            {hasPayments ? (
                isMobile ? (
                    <MobileCards />
                ) : (
                    <DesktopTable />
                )
            ) : (
                <EmptyData />
            )}

            {totalPayments > 0 && (
                <div className="mt-4">
                    <CustomPagination
                        total={totalPayments}
                        onPageChange={(page, perPage) => {
                            fetchData(page, perPage);
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default Payments;

